export enum IHostsListPageTabs {
  HostsList = 'list',
  ResourceUtilization = 'resource-utilization',
}

export const searchTargets = [
  'name',
  'id',
  'interfaces',
  'clusterName',
  'roleStatuses',
  'responding',
  'schedulingStatus',
]
